module.exports = "/static/assets/59c79fa681b1421547664294a259b2d8.svg";